/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
import { Order } from '../../../../Types/BeecomingTypes/BeecomingTypes';
import GetComparatorFromKeyInterface from '../../../../Types/Interface/MethodInterface/GetComparatorFromKeyInterface';
import ActualityInterface from '../../../../Types/Interface/TableInterfaces/DataInterface/ActualityInterface';

const GetActualityComparatorFromKey: GetComparatorFromKeyInterface<ActualityInterface> = (
  key: keyof ActualityInterface,
  typeOrder: Order,
) => {
  const sign: number = typeOrder === 'asc' ? 1 : -1;
  switch (key) {
    case 'title':
      return (a: ActualityInterface, b: ActualityInterface) =>
        sign * a.title.localeCompare(b.title);

    case 'level':
      return (a: ActualityInterface, b: ActualityInterface) => sign * (a.level - b.level);
    default:
      return (a: ActualityInterface, b: ActualityInterface) =>
        sign * a[key].toLocaleString().localeCompare(b[key].toLocaleString());
  }
};

export default GetActualityComparatorFromKey;
